import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

type ContractIdParams = {
  contractId: string;
};

export function useContractId(defaultId: string | undefined) {
  const { contractId } = useParams<ContractIdParams>();

  return useMemo(() => contractId ?? defaultId ?? '', [contractId, defaultId]);
}